// extracted by mini-css-extract-plugin
export default {"phoneWrap":"AuthInformation_phoneWrap__UZRJ-"};